import React from 'react';

const Loading = () => <div className="my-5 mx-auto">Loading...</div>;

export default Loading;
